import React from 'react';
import {  Show,
ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,
ReferenceInput, SelectInput
 }
from 'admin-on-rest/lib/mui';

export const PlanList = (props) => (
    <List title="תוכניות חיוב" {...props}>
        <Datagrid>
            <TextField label="#" source="id" />
             <TextField label="תוכנית" source="plan" />
              <TextField  source="monthly_cap" />
    <TextField  source="monthly_fee" />
   <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

const PostTitle = ({ record }) => {
    return <span> {record ? `${record.plan}` : ''}</span>;
};


export const PlanShow = (props) => (

<Show title={<PostTitle />} {...props}>
 <SimpleShowLayout>
        <TextField label="#" source="id" />
        <TextField label="תוכנית חיוב" source="plan" />
          <TextField  source="monthly_cap" />
          <TextField  source="setup_fee" />
          <TextField  source="monthly_fee" />
          <TextField  source="prepayment" />
          <TextField  source="additional_terminal_fee" />
          <TextField  source="discount_payments" />
          <TextField  source="cap_exception" />
          <TextField  source="tourist_card_commision" />
          <TextField  source="cancel_transaction_commision" />
          <TextField  source="mismach_haser_commision" />
          <TextField  source="payments_commision" />
          <TextField  source="additional_payments_commision" />
          <TextField  source="hardware_fee" />
            <TextField source="commission" label="עמלה"/>
            <TextField source="zicui_date_plan_id" label="מועדי זיכוי"/>
            <TextField source="total_transactions_limit" label="כמות טרנסאקציות"/>

        <RichTextField label="פרטים" source="details" />

         </SimpleShowLayout>
    </Show>
);


export const PlanEdit = (props) => (

<Edit title={<PostTitle />} {...props}>

        <SimpleForm>
 <DisabledInput source="id" />
<TextInput  source="plan" />
<TextInput  source="details" />
  <TextInput  source="monthly_cap" />
  <TextInput  source="setup_fee" />
  <TextInput  source="monthly_fee" />
  <TextInput  source="prepayment" />
  <TextInput  source="additional_terminal_fee" />
  <TextInput  source="discount_payments" />
  <TextInput  source="cap_exception" />
  <TextInput  source="tourist_card_commision" />
  <TextInput  source="cancel_transaction_commision" />
  <TextInput  source="mismach_haser_commision" />
  <TextInput  source="payments_commision" />
  <TextInput  source="additional_payments_commision" />
  <TextInput  source="hardware_fee" />
    <TextInput source="commission" label="עמלה"/>
    
    <ReferenceInput label="מועדי זיכוי" source="zicui_date_plan_id" reference="zicuidateplans" allowEmpty>
        <SelectInput optionText="name" />
    </ReferenceInput>

    <TextInput source="total_transactions_limit" label="כמות טרנסאקציות"/>
        </SimpleForm>
  </Edit>
);




              



// WEBPACK FOOTER //
// ./src/components/Plans/plans.js